module.exports = __webpack_public_path__ + "static/media/uit5.2d3a4241.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/uit5.jpg
// module id = 5809
// module chunks = 0